export default __webpack_public_path__ + "styles.36d6e6ed0aa89cd5e523177c64306e2d.css";